import pic_0 from './images/0.jpg';
import pic_1 from './images/1.jpg';
import pic_2 from './images/2.jpg';
import pic_3 from './images/3.jpg';
import pic_4 from './images/4.jpg';
import pic_5 from './images/5.jpg';
import pic_6 from './images/6.jpg';
import pic_7 from './images/7.jpg';
import pic_8 from './images/8.jpg';
import pic_9 from './images/9.jpg';
import pic_10 from './images/10.jpg';
import pic_11 from './images/11.jpg';
import pic_12 from './images/12.jpg';
import pic_13 from './images/13.jpg';
import pic_14 from './images/14.jpg';
import pic_15 from './images/15.jpg';
import pic_16 from './images/16.jpg';
import pic_17 from './images/17.jpg';
import pic_18 from './images/18.jpg';
import pic_19 from './images/19.jpg';
import pic_20 from './images/20.jpg';
import pic_21 from './images/21.jpg';
import pic_22 from './images/22.jpg';
import pic_23 from './images/23.jpg';
import pic_24 from './images/24.jpg';
import pic_25 from './images/25.jpg';
import pic_26 from './images/26.jpg';
import pic_27 from './images/27.jpg';
import pic_28 from './images/28.jpg';
import pic_29 from './images/29.jpg';
import pic_30 from './images/30.jpg';
import { randomItem } from '../utils/utils';

const images = [
  pic_0,
  pic_1,
  pic_2,
  pic_3,
  pic_4,
  pic_5,
  pic_6,
  pic_7,
  pic_8,
  pic_9,
  pic_10,
  pic_11,
  pic_12,
  pic_13,
  pic_14,
  pic_15,
  pic_16,
  pic_17,
  pic_18,
  pic_19,
  pic_20,
  pic_21,
  pic_22,
  pic_23,
  pic_24,
  pic_25,
  pic_26,
  pic_27,
  pic_28,
  pic_29,
  pic_30,
];

const generateRandomImage =()=> randomItem(images);

export const fakeSongsList = {
  data: [
    {
      id: 1425844092,
      readable: true,
      title: 'STAY',
      title_short: 'STAY',
      title_version: '',
      link: 'http://www.deezer.com/track/1425844092',
      duration: 141,
      rank: 989040,
      explicit_lyrics: true,
      explicit_content_lyrics: 1,
      explicit_content_cover: 2,
      preview:
        'http://cdn-preview-f.deezer.com/stream/c-fd9572c7a11401267a6c5c3402254160-5.mp3',
      md5_image: 'dd6fe7fa9267185c4b835bd4f155d1d2',
      artist: {
        id: 51204222,
        name: 'The Kid Laroi',
        link: 'http://www.deezer.com/artist/51204222',
        picture: 'http://api.deezer.com/artist/51204222/image',
        picture_medium: generateRandomImage(),
        tracklist: 'http://api.deezer.com/artist/51204222/top?limit=50',
        type: 'artist',
      },
      album: {
        id: 242430582,
        title: 'STAY',
        cover: 'http://api.deezer.com/album/242430582/image',
        cover_big: generateRandomImage(),
        md5_image: 'dd6fe7fa9267185c4b835bd4f155d1d2',
        tracklist: 'http://api.deezer.com/album/242430582/tracks',
        type: 'album',
      },
      type: 'track',
    },
    {
      id: 112662368,
      readable: true,
      title: 'Love Yourself',
      title_short: 'Love Yourself',
      title_version: '',
      link: 'http://www.deezer.com/track/112662368',
      duration: 233,
      rank: 897854,
      explicit_lyrics: false,
      explicit_content_lyrics: 0,
      explicit_content_cover: 0,
      preview:
        'http://cdn-preview-8.deezer.com/stream/c-82688112a6cce207f260a5b91241c25f-7.mp3',
      md5_image: '340283aafac320864b207c420124ee46',
      artist: {
        id: 288166,
        name: 'Justin Bieber',
        link: 'http://www.deezer.com/artist/288166',
        picture: 'http://api.deezer.com/artist/288166/image',
        picture_medium: generateRandomImage(),
        tracklist: 'http://api.deezer.com/artist/288166/top?limit=50',
        type: 'artist',
      },
      album: {
        id: 11674708,
        title: 'Purpose (Deluxe)',
        cover: 'http://api.deezer.com/album/11674708/image',
        cover_big: generateRandomImage(),
        md5_image: '340283aafac320864b207c420124ee46',
        tracklist: 'http://api.deezer.com/album/11674708/tracks',
        type: 'album',
      },
      type: 'track',
    },
    {
      id: 969494,
      readable: true,
      title: 'Cry Me a River',
      title_short: 'Cry Me a River',
      title_version: '',
      link: 'http://www.deezer.com/track/969494',
      duration: 288,
      rank: 847108,
      explicit_lyrics: false,
      explicit_content_lyrics: 0,
      explicit_content_cover: 0,
      preview:
        'http://cdn-preview-0.deezer.com/stream/c-065c43d27032a85c93bf25f48f08e706-7.mp3',
      md5_image: '7cba368fa8466d72d149264577cb19d7',
      artist: {
        id: 1147,
        name: 'Justin Timberlake',
        link: 'http://www.deezer.com/artist/1147',
        picture: 'http://api.deezer.com/artist/1147/image',
        picture_medium: generateRandomImage(),
        tracklist: 'http://api.deezer.com/artist/1147/top?limit=50',
        type: 'artist',
      },
      album: {
        id: 108359,
        title: 'Justified',
        cover: 'http://api.deezer.com/album/108359/image',
        cover_big: generateRandomImage(),
        md5_image: '7cba368fa8466d72d149264577cb19d7',
        tracklist: 'http://api.deezer.com/album/108359/tracks',
        type: 'album',
      },
      type: 'track',
    },
    {
      id: 112662364,
      readable: true,
      title: 'What Do You Mean?',
      title_short: 'What Do You Mean?',
      title_version: '',
      link: 'http://www.deezer.com/track/112662364',
      duration: 205,
      rank: 884297,
      explicit_lyrics: false,
      explicit_content_lyrics: 0,
      explicit_content_cover: 0,
      preview:
        'http://cdn-preview-e.deezer.com/stream/c-edd4a56243d6b3ca2c5043bbe0c3226c-7.mp3',
      md5_image: '340283aafac320864b207c420124ee46',
      artist: {
        id: 288166,
        name: 'Justin Bieber',
        link: 'http://www.deezer.com/artist/288166',
        picture: 'http://api.deezer.com/artist/288166/image',
        picture_medium: generateRandomImage(),
        tracklist: 'http://api.deezer.com/artist/288166/top?limit=50',
        type: 'artist',
      },
      album: {
        id: 11674708,
        title: 'Purpose (Deluxe)',
        cover: 'http://api.deezer.com/album/11674708/image',
        cover_big: generateRandomImage(),
        md5_image: '340283aafac320864b207c420124ee46',
        tracklist: 'http://api.deezer.com/album/11674708/tracks',
        type: 'album',
      },
      type: 'track',
    },
    {
      id: 124237488,
      readable: true,
      title: 'CAN\'T STOP THE FEELING! (from DreamWorks Animation\'s "TROLLS")',
      title_short:
        'CAN\'T STOP THE FEELING! (from DreamWorks Animation\'s "TROLLS")',
      title_version: '',
      link: 'http://www.deezer.com/track/124237488',
      duration: 236,
      rank: 877949,
      explicit_lyrics: false,
      explicit_content_lyrics: 0,
      explicit_content_cover: 0,
      preview:
        'http://cdn-preview-8.deezer.com/stream/c-8e2950c9eaf0c5c9bd8621dc855099f4-7.mp3',
      md5_image: '209aa560e3b5fbe679e91887fc0c7332',
      artist: {
        id: 1147,
        name: 'Justin Timberlake',
        link: 'http://www.deezer.com/artist/1147',
        picture: 'http://api.deezer.com/artist/1147/image',
        picture_medium: generateRandomImage(),
        tracklist: 'http://api.deezer.com/artist/1147/top?limit=50',
        type: 'artist',
      },
      album: {
        id: 13035460,
        title:
          'CAN\'T STOP THE FEELING! (from DreamWorks Animation\'s "TROLLS")',
        cover: 'http://api.deezer.com/album/13035460/image',
        cover_big: generateRandomImage(),
        md5_image: '209aa560e3b5fbe679e91887fc0c7332',
        tracklist: 'http://api.deezer.com/album/13035460/tracks',
        type: 'album',
      },
      type: 'track',
    },
    {
      id: 15489383,
      readable: true,
      title: 'SexyBack (feat. Timbaland)',
      title_short: 'SexyBack (feat. Timbaland)',
      title_version: '',
      link: 'http://www.deezer.com/track/15489383',
      duration: 242,
      rank: 865108,
      explicit_lyrics: false,
      explicit_content_lyrics: 3,
      explicit_content_cover: 0,
      preview:
        'http://cdn-preview-2.deezer.com/stream/c-21c2310ec488caad34a0c679e7833c71-4.mp3',
      md5_image: '615bb58abf2e5fd86741ed5311d364b1',
      artist: {
        id: 1147,
        name: 'Justin Timberlake',
        link: 'http://www.deezer.com/artist/1147',
        picture: 'http://api.deezer.com/artist/1147/image',
        picture_medium: generateRandomImage(),
        tracklist: 'http://api.deezer.com/artist/1147/top?limit=50',
        type: 'artist',
      },
      album: {
        id: 1431361,
        title: 'FutureSex/LoveSounds Deluxe Edition',
        cover: 'http://api.deezer.com/album/1431361/image',
        cover_big: generateRandomImage(),
        md5_image: '615bb58abf2e5fd86741ed5311d364b1',
        tracklist: 'http://api.deezer.com/album/1431361/tracks',
        type: 'album',
      },
      type: 'track',
    },
    {
      id: 970410,
      readable: true,
      title: 'Rock Your Body',
      title_short: 'Rock Your Body',
      title_version: '',
      link: 'http://www.deezer.com/track/970410',
      duration: 267,
      rank: 834629,
      explicit_lyrics: false,
      explicit_content_lyrics: 0,
      explicit_content_cover: 0,
      preview:
        'http://cdn-preview-f.deezer.com/stream/c-ff741992748853e16623aa4c5b7d4c19-8.mp3',
      md5_image: '7cba368fa8466d72d149264577cb19d7',
      artist: {
        id: 1147,
        name: 'Justin Timberlake',
        link: 'http://www.deezer.com/artist/1147',
        picture: 'http://api.deezer.com/artist/1147/image',
        picture_medium: generateRandomImage(),
        tracklist: 'http://api.deezer.com/artist/1147/top?limit=50',
        type: 'artist',
      },
      album: {
        id: 108359,
        title: 'Justified',
        cover: 'http://api.deezer.com/album/108359/image',
        cover_big: generateRandomImage(),
        md5_image: '7cba368fa8466d72d149264577cb19d7',
        tracklist: 'http://api.deezer.com/album/108359/tracks',
        type: 'album',
      },
      type: 'track',
    },
    {
      id: 112662366,
      readable: true,
      title: 'Sorry',
      title_short: 'Sorry',
      title_version: '',
      link: 'http://www.deezer.com/track/112662366',
      duration: 200,
      rank: 852295,
      explicit_lyrics: false,
      explicit_content_lyrics: 0,
      explicit_content_cover: 0,
      preview:
        'http://cdn-preview-4.deezer.com/stream/c-4aec008ea277bade72bb31f331301b0c-7.mp3',
      md5_image: '340283aafac320864b207c420124ee46',
      artist: {
        id: 288166,
        name: 'Justin Bieber',
        link: 'http://www.deezer.com/artist/288166',
        picture: 'http://api.deezer.com/artist/288166/image',
        picture_medium: generateRandomImage(),
        tracklist: 'http://api.deezer.com/artist/288166/top?limit=50',
        type: 'artist',
      },
      album: {
        id: 11674708,
        title: 'Purpose (Deluxe)',
        cover: 'http://api.deezer.com/album/11674708/image',
        cover_big: generateRandomImage(),
        md5_image: '340283aafac320864b207c420124ee46',
        tracklist: 'http://api.deezer.com/album/11674708/tracks',
        type: 'album',
      },
      type: 'track',
    },
    {
      id: 10047260,
      readable: true,
      title: 'Justine',
      title_short: 'Justine',
      title_version: '',
      link: 'http://www.deezer.com/track/10047260',
      duration: 229,
      rank: 373207,
      explicit_lyrics: false,
      explicit_content_lyrics: 0,
      explicit_content_cover: 2,
      preview:
        'http://cdn-preview-3.deezer.com/stream/c-3ba835bf1bb7fc77169d5360cf0575bb-2.mp3',
      md5_image: '7b6fdbdd60ed898f40c18798f7adfe92',
      artist: {
        id: 47,
        name: 'Indochine',
        link: 'http://www.deezer.com/artist/47',
        picture: 'http://api.deezer.com/artist/47/image',
        picture_medium: generateRandomImage(),
        tracklist: 'http://api.deezer.com/artist/47/top?limit=50',
        type: 'artist',
      },
      album: {
        id: 919739,
        title: 'Dancetaria',
        cover: 'http://api.deezer.com/album/919739/image',
        cover_big: generateRandomImage(),
        md5_image: '7b6fdbdd60ed898f40c18798f7adfe92',
        tracklist: 'http://api.deezer.com/album/919739/tracks',
        type: 'album',
      },
      type: 'track',
    },
    {
      id: 1280165222,
      readable: true,
      title: 'Peaches',
      title_short: 'Peaches',
      title_version: '',
      link: 'http://www.deezer.com/track/1280165222',
      duration: 198,
      rank: 918159,
      explicit_lyrics: true,
      explicit_content_lyrics: 1,
      explicit_content_cover: 1,
      preview:
        'http://cdn-preview-1.deezer.com/stream/c-179bee1bfc65440d7df06d2246209699-4.mp3',
      md5_image: '87468622c8e7ac9dce7b541be136aa4c',
      artist: {
        id: 288166,
        name: 'Justin Bieber',
        link: 'http://www.deezer.com/artist/288166',
        picture: 'http://api.deezer.com/artist/288166/image',
        picture_medium: generateRandomImage(),
        tracklist: 'http://api.deezer.com/artist/288166/top?limit=50',
        type: 'artist',
      },
      album: {
        id: 215962322,
        title: 'Justice',
        cover: 'http://api.deezer.com/album/215962322/image',
        cover_big: generateRandomImage(),
        md5_image: '87468622c8e7ac9dce7b541be136aa4c',
        tracklist: 'http://api.deezer.com/album/215962322/tracks',
        type: 'album',
      },
      type: 'track',
    },
    {
      id: 1280165212,
      readable: true,
      title: 'Ghost',
      title_short: 'Ghost',
      title_version: '',
      link: 'http://www.deezer.com/track/1280165212',
      duration: 153,
      rank: 859670,
      explicit_lyrics: false,
      explicit_content_lyrics: 0,
      explicit_content_cover: 1,
      preview:
        'http://cdn-preview-5.deezer.com/stream/c-5a5fb2a297fc05d6e42cc359c5602e24-4.mp3',
      md5_image: '87468622c8e7ac9dce7b541be136aa4c',
      artist: {
        id: 288166,
        name: 'Justin Bieber',
        link: 'http://www.deezer.com/artist/288166',
        picture: 'http://api.deezer.com/artist/288166/image',
        picture_medium: generateRandomImage(),
        tracklist: 'http://api.deezer.com/artist/288166/top?limit=50',
        type: 'artist',
      },
      album: {
        id: 215962322,
        title: 'Justice',
        cover: 'http://api.deezer.com/album/215962322/image',
        cover_big: generateRandomImage(),
        md5_image: '87468622c8e7ac9dce7b541be136aa4c',
        tracklist: 'http://api.deezer.com/album/215962322/tracks',
        type: 'album',
      },
      type: 'track',
    },
    {
      id: 1108107,
      readable: true,
      title: 'Justine',
      title_short: 'Justine',
      title_version: '',
      link: 'http://www.deezer.com/track/1108107',
      duration: 170,
      rank: 303183,
      explicit_lyrics: false,
      explicit_content_lyrics: 0,
      explicit_content_cover: 2,
      preview:
        'http://cdn-preview-e.deezer.com/stream/c-e37da264549aeab16fb668ab62ced458-4.mp3',
      md5_image: '64543dff2ad34f979d0fddf749807315',
      artist: {
        id: 447,
        name: 'Nino Ferrer',
        link: 'http://www.deezer.com/artist/447',
        picture: 'http://api.deezer.com/artist/447/image',
        picture_medium: generateRandomImage(),
        tracklist: 'http://api.deezer.com/artist/447/top?limit=50',
        type: 'artist',
      },
      album: {
        id: 119517,
        title: 'Les 50 Plus Belles Chansons',
        cover: 'http://api.deezer.com/album/119517/image',
        cover_big: generateRandomImage(),
        md5_image: '64543dff2ad34f979d0fddf749807315',
        tracklist: 'http://api.deezer.com/album/119517/tracks',
        type: 'album',
      },
      type: 'track',
    },
    {
      id: 1324559462,
      readable: true,
      title: 'Iko Iko (My Bestie) (feat. Small Jam)',
      title_short: 'Iko Iko (My Bestie) (feat. Small Jam)',
      title_version: '',
      link: 'http://www.deezer.com/track/1324559462',
      duration: 182,
      rank: 916859,
      explicit_lyrics: false,
      explicit_content_lyrics: 0,
      explicit_content_cover: 2,
      preview:
        'http://cdn-preview-4.deezer.com/stream/c-450e1379822ed8cf835b99990dd0e863-3.mp3',
      md5_image: '96b834af0523df5abf19dd40f59923c5',
      artist: {
        id: 1944941,
        name: 'Justin Wellington',
        link: 'http://www.deezer.com/artist/1944941',
        picture: 'http://api.deezer.com/artist/1944941/image',
        picture_medium: generateRandomImage(),
        tracklist: 'http://api.deezer.com/artist/1944941/top?limit=50',
        type: 'artist',
      },
      album: {
        id: 220792432,
        title: 'Iko Iko (My Bestie) (feat. Small Jam)',
        cover: 'http://api.deezer.com/album/220792432/image',
        cover_big: generateRandomImage(),
        md5_image: '96b834af0523df5abf19dd40f59923c5',
        tracklist: 'http://api.deezer.com/album/220792432/tracks',
        type: 'album',
      },
      type: 'track',
    },
    {
      id: 129632340,
      readable: true,
      title: 'Let Me Love You',
      title_short: 'Let Me Love You',
      title_version: '',
      link: 'http://www.deezer.com/track/129632340',
      duration: 205,
      rank: 884421,
      explicit_lyrics: false,
      explicit_content_lyrics: 0,
      explicit_content_cover: 1,
      preview:
        'http://cdn-preview-7.deezer.com/stream/c-7a5481844dac62c0a709a6af7ffe542f-6.mp3',
      md5_image: '6a52e1bbddc750c996a66b0ccfa4370c',
      artist: {
        id: 482758,
        name: 'DJ Snake',
        link: 'http://www.deezer.com/artist/482758',
        picture: 'http://api.deezer.com/artist/482758/image',
        picture_medium: generateRandomImage(),
        tracklist: 'http://api.deezer.com/artist/482758/top?limit=50',
        type: 'artist',
      },
      album: {
        id: 13726450,
        title: 'Encore',
        cover: 'http://api.deezer.com/album/13726450/image',
        cover_big: generateRandomImage(),
        md5_image: '6a52e1bbddc750c996a66b0ccfa4370c',
        tracklist: 'http://api.deezer.com/album/13726450/tracks',
        type: 'album',
      },
      type: 'track',
    },
    {
      id: 138133005,
      readable: true,
      title: 'Just In',
      title_short: 'Just In',
      link: 'http://www.deezer.com/track/138133005',
      duration: 302,
      rank: 249571,
      explicit_lyrics: false,
      explicit_content_lyrics: 0,
      explicit_content_cover: 2,
      preview:
        'http://cdn-preview-6.deezer.com/stream/c-65d076ac028236638fcf60db8922336c-5.mp3',
      md5_image: 'cea061b241f17213417bb010c8baa782',
      artist: {
        id: 172571,
        name: 'Rakoon',
        link: 'http://www.deezer.com/artist/172571',
        picture: 'http://api.deezer.com/artist/172571/image',
        picture_medium: generateRandomImage(),
        tracklist: 'http://api.deezer.com/artist/172571/top?limit=50',
        type: 'artist',
      },
      album: {
        id: 14831823,
        title: 'Our Smiles',
        cover: 'http://api.deezer.com/album/14831823/image',
        cover_big: generateRandomImage(),
        md5_image: 'cea061b241f17213417bb010c8baa782',
        tracklist: 'http://api.deezer.com/album/14831823/tracks',
        type: 'album',
      },
      type: 'track',
    },
  ],
  total: 319,
  next: 'http://api.deezer.com/search?limit=15&q=justin&index=15',
};

export const fakeSongLyrics = `
API NOT WORKING SHOWING DUMMY LYRICS

Gimme, gimme, gimme some time to think
I’m in the bathroom, looking at me
Face in the mirror is all I need (Ooh-ooh)
Wait until the reaper takes my life
Never gonna get me out alive
I will live a thousand million lives (Ooh-ooh)

My patience is waning, is this entertaining?
Our patience is waning, is this entertaining?

I-I-I got this feeling, yeah, you know
Where I’m losing all control
‘Cause there’s magic in my bones
I-I-I got this feeling in my soul
Go ahead and throw your stones
‘Cause there’s magic in my bones

Playin’ with a stick of dynamitе
There was nevеr gray in black and white
There was never wrong ’til there was right (Ooh-ooh)
Feelin’ like a boulder hurtlin’
Seein’ all the vultures circlin’
Burnin’ in the flames, I’m workin’ in
Turnin’ in a bed, that’s darkenin’

My patience is waning, is this entertaining?
Our patience is waning, is this entertaining?

I-I-I got this feeling, yeah, you know
Where I’m losing all control
‘Cause there’s magic in my bones (In my bones)
I-I-I got this feeling in my soul
Go ahead and throw your stones
‘Cause there’s magic in my bones

‘Cause there’s magic in my bones

Look in the mirror of my mind
Turnin’ the pages of my life
Walkin’ the path so many paced a million times
Drown out the voices in the air
Leavin’ the ones that never cared
Pickin’ the pieces up and buildin’ to the sky

My patience is waning, is this entertaining?
My patience is waning, is this entertaining?

I-I-I got this feeling, yeah, you know
Where I’m losing all control
‘Cause there’s magic in my bones (Magic in my bones)
I-I-I got this feeling in my soul (Soul)
Go ahead and throw your stones
‘Cause there’s magic in my bones

There goes my mind, (I-I-I) don’t mind
There goes my mind (There it goes, there it goes)
There goes my mind, (I-I-I) don’t mind
There goes my mind (There it goes)
‘Cause there’s magic in my bones`;
